<template>
    <div
        class="modal_header"
        :class="[classes, border && 'border-b border-gray-100']"
    >
        <button type="button" @click="onCloseHeader" class="flex mr-4">
            <fa :icon="['fal', 'xmark']"></fa>
        </button>
        <h4 class="capitalize" v-if="headingText && !headingIcon">
            {{ headingText }}
        </h4>
        <h4 v-if="headingText && headingIcon" class="flex items-center">
            <div
                class="warp_icon w-8 h-8 flex items-center justify-center mr-1"
            >
                <span
                    class="absolute top-0 left-0 z-0 h-full w-full opacity-30 rounded-full"
                    :style="`background:${modalIconColor}`"
                >
                </span>
                <div
                    class="w-6 h-6 flex items-center justify-center rounded-full z-30"
                    :style="`background:${modalIconColor}`"
                >
                    <fa
                        :icon="['fal', headingIcon]"
                        class="!text-white z-10 !text-xs m-auto"
                    ></fa>
                </div>
            </div>
            {{ headingText }}
        </h4>

        <slot name="modalHeaderLeft"></slot>
        <slot name="modalHeaderRight"></slot>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import useToggleModal from '@/composables/useToggleModal';
import { useHeaderStore } from '@/stores/headerStore.js';
const headerStore = useHeaderStore();
const emit = defineEmits(['onHeaderToggle']);
const props = defineProps({
    headingText: {
        type: String,
        default: '',
    },
    headingIcon: {
        type: String,
        default: '',
    },
    modalIconColor: {
        type: String,
        default: '',
    },
    classes: {
        type: String,
    },
    directClose: {
        type: Boolean,
    },
    border: {
        type: Boolean,
        default: false,
    },
});
const onHeaderToggle = () => {
    // emit('onHeaderToggle');
    props.directClose ? toggleModal() : false;
};
const { toggleModal } = useToggleModal();
const onCloseHeader = () => {
    onHeaderToggle();
    emit('onHeaderToggle');
    headerStore.setBoardFormName('');
};
</script>

<style scoped>
.modal_header {
    @apply flex items-center px-6 py-8 sm:pb-2 xs:pt-6 xs:pb-4 dark:border-black-900 static top-0 bg-white dark:bg-dm-whitebg left-0 right-0 z-50;
}

svg {
    @apply text-gray-200 text-2xl dark:text-gray-600 w-[18px];
}

.modal_header h4 {
    @apply text-black-900 dark:text-dm-white text-lg font-semibold mr-auto leading-normal;
}
</style>
